<div #masonry class="masonry" class="hidden">
  <div class="item" *ngFor="let obs of observer | async; index as i">
    <img
      #items
      (click)="displayDialog(obs, i)"
      (contextmenu)="disableRightClick(e)"
      (load)="showImage(i)"
      src="{{ obs }}"
      routerLink="../full"
    />
  </div>
</div>

<div class="moveSpinner" *ngIf="spinner">
  <div></div>
  <mat-progress-spinner [diameter]="diameter" [mode]="mode" [value]="value">
  </mat-progress-spinner>
  <div></div>
</div>
